import { atom } from "@byko/lib-recoil";

import type { Position } from "../interface";

export const messagePositionState = atom<Position>({
  key: "toast-message-position",
  default: "bottom-left",
});
